import script from "./QueueTable.vue?vue&type=script&setup=true&lang=js"
export * from "./QueueTable.vue?vue&type=script&setup=true&lang=js"

import "./QueueTable.vue?vue&type=style&index=0&id=2db4fda6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2db4fda6"]])

export default __exports__